const BLOG = {
    onReady() {
        document.addEventListener('click', BLOG.filterClick);
    },
    /*********************
    * Filter Click XHR request
    *********************/
    filterClick(event) {
        let filter = event.target.closest('.blog-overview__filter');
        if (filter === null) return;
        event.preventDefault();
        XHR.load({
            nodeIds: [ 'blog-overview' ],
            url: filter.href
        });
        window.history.replaceState(null, '', filter.href);
    }
}